import StatisticsChart from "./StatisticsChart";

const PALETTE = [
  "#388e3c",
  "#0288d1",
  "#f44336",
  "#ed6c02",
  "#675DFF",
  "#B2B2BA",
  "#000000",
];

export const TimeChart = ({
  title,
  categories,
  series,
  isLoading = false,
  format = "number",
  stacked = true,
  projectedCount = 0,
}: {
  title: string;
  categories: string[];
  series: { name: string; data: number[] }[];
  isLoading?: boolean;
  format?: "number" | "currency" | "percent";
  stacked?: boolean;
  projectedCount?: number;
}) => {
  const formatter = (val: number) => {
    if (val == null || isNaN(val)) return "";
    if (format === "currency") {
      return val.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      });
    }
    if (format === "percent") {
      return `${val.toFixed(1)}%`;
    }
    return Math.round(val).toLocaleString("en-US");
  };

  return (
    <StatisticsChart
      color="white"
      title={title}
      isLoading={isLoading}
      containerClassName="h-80 md:h-[640px]"
      chart={{
        type: "area",
        height: "100%",
        series,
        options: {
          colors: PALETTE,
          chart: {
            type: "area",
            stacked,
            toolbar: { show: false },
            zoom: { enabled: false },
            ...(projectedCount > 0 && {
              forecastDataPoints: {
                count: projectedCount,
                fillOpacity: 0.4,
                strokeWidth: undefined,
                dashArray: 6,
              },
            }),
          },
          dataLabels: { enabled: false },
          stroke: { curve: "straight", width: 2 },
          markers: { size: 2, strokeWidth: 0, hover: { sizeOffset: 2 } },
          fill: { type: "solid", opacity: 0.2 },
          grid: {
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: true } },
          },
          xaxis: {
            type: "datetime",
            categories,
            labels: { datetimeUTC: true },
            tickAmount: Math.min(Math.max(categories.length - 1, 1), 24),
          },
          yaxis: {
            labels: { formatter: formatter as any },
          },
          tooltip: {
            x: { format: "MMM d, yyyy" },
            y: { formatter: formatter as any },
          },
          legend: { position: "top", horizontalAlign: "left" },
        },
      }}
    />
  );
};

export default TimeChart;
